







































































import { Component, Vue, Prop } from "vue-property-decorator";
import axios from 'axios';
import { General } from '@/services/General';
import { Sign } from "@/entity/Sign";
import GarageSignDetails from "./GarageSignDetails.vue";
import GarageSignStatusChange from "./GarageSignStatusChange.vue";
import { SignStatus } from "@/services/Enums";
import { Garage } from "@/entity/Garage";

@Component({
    components: {
      GarageSignDetails,
      GarageSignStatusChange
    }
  })
export default class GarageSigns extends Vue {
  @Prop({
          required: true
      })
  signs: Array<Sign>;
  @Prop({
          required: false
      })    
  editable: boolean;
  @Prop({ required: true })
  garage : Garage;

  SIGN_MODAL_TITLE_INSERT_MODE: string = "Crea una nuova insegna";
  SIGN_MODAL_TITLE_EDIT_MODE: string = "Modifica dati insegna";

  status:number = 0;
  loading: boolean = false;
  parentModalMounted: boolean = false;
  signModalTitle: string = this.SIGN_MODAL_TITLE_INSERT_MODE;
  signStatusModalTitle: string = "";
  signDetailModalEditMode: boolean = true;
  signSelected: Sign = null; 
  signsLoaded: Array<Sign> = [];
  signStatusEnum: any = SignStatus;

  mounted(){
    this.signsLoaded = this.signs;
    this.signsLoaded.forEach(element => {
      this.setSignCssAndPermissions(element);
    });
    this.parentModalMounted = true;
  }

  openChangeStatusModal(sign: Sign = null, newStatus: number) {
    this.signSelected = sign;
    this.status = newStatus;
    
    switch (this.status) {
      case this.signStatusEnum.CONSEGNATA:
        this.signStatusModalTitle = "Consegna"
        break;
      case this.signStatusEnum.RITIRATA:
        this.signStatusModalTitle = "Ritiro / Rimozione"
        break;
      case this.signStatusEnum.ROTTAMATA:
        this.signStatusModalTitle = "Rottamazione"
        break;
      case this.signStatusEnum.DANNEGGIATA:
        this.signStatusModalTitle = "Danneggiamento"
        break;
    }
    this.signStatusModalTitle = this.signStatusModalTitle + " Insegna"
    this.$bvModal.show('garage-sign-status-modal');
  }

  openSignDetail(sign: Sign = null) {
    if(sign != null) {
      this.openSignDetailEditMode(sign);
    } else {
      this.openSignDetailInsertMode();
    }
  }

  openSignDetailEditMode(sign: Sign) {
    this.signSelected = sign;
    this.signDetailModalEditMode = true;
    this.signModalTitle = this.SIGN_MODAL_TITLE_EDIT_MODE;
    this.openSignDetailModal();
  }

  openSignDetailInsertMode() {
    this.signSelected = null;
    this.signDetailModalEditMode = false;
    this.signModalTitle = this.SIGN_MODAL_TITLE_INSERT_MODE;
    this.openSignDetailModal();
  }

  openSignDetailModal() {
    this.$bvModal.show('garage-sign-details-modal');
  }

  async actionOnSigns(sign: Sign, editMode:boolean = true) {
    this.loading = true;
    var freshSign = await this.getSignById(sign.id);
    this.setSignCssAndPermissions(freshSign);
    let indexToUpdate = this.signs.findIndex((x) => x.id === sign.id)

    if(editMode)
      Vue.set(this.signs, indexToUpdate, freshSign);
    else
      this.signs.push(freshSign);

    this.loading = false;
  }

  async getSignById(idSign: string) : Promise<Sign> {
    try {
      let response = await axios.get<any>(
        General.GetApiUrl("/api/Sign/GetSignById?signId=" + idSign),
        {
          withCredentials: true,
        }
      );
      if(response.data != null)
        return response.data as Sign;
    } catch (error) {
      General.HandleError(error, this);
    }
  }
  
  setSignCssAndPermissions(sign: Sign) {
    switch (sign.stato) {
      case this.signStatusEnum.ORDINATA:
        sign.isEditable = true;
        sign.isDamageable = false;
        sign.isDeliverable = true;
        sign.isScrapped = false;
        sign.isRemovable = true;
        break;
      case this.signStatusEnum.CONSEGNATA:
        sign.cssStato = "blue";

        sign.isEditable = true;
        sign.isDamageable = true;
        sign.isDeliverable = false;
        sign.isScrapped = true;
        sign.isRemovable = true;
        break;
      case this.signStatusEnum.DANNEGGIATA:
        sign.cssStato = "orange";
        sign.isEditable = false;
        sign.isDamageable = false;
        sign.isDeliverable = false;
        sign.isScrapped = true;
        sign.isRemovable = true;
        break;
      case this.signStatusEnum.RITIRATA:
        sign.cssStato = "red";

        sign.isEditable = false;
        sign.isDamageable = false;
        sign.isDeliverable = false;
        sign.isScrapped = false;
        sign.isRemovable = false;
        break;
      case this.signStatusEnum.IRREPERIBILE:
        sign.cssStato = "purple";

        sign.isEditable = false;
        sign.isDamageable = false;
        sign.isDeliverable = false;
        sign.isScrapped = false;
        sign.isRemovable = false;
        break;
      case this.signStatusEnum.ROTTAMATA:
        sign.cssStato = "darkred";

        sign.isEditable = false;
        sign.isEditable = false;
        sign.isDamageable = false;
        sign.isDeliverable = false;
        sign.isScrapped = false;
        sign.isRemovable = false;
        break;
    }
  }
}
